import React, { useState } from 'react'
import { connect } from 'react-redux'

import DetailsHolder from '../DetailsHolder'
import Campus from '../../../College/CampusForm'
import FormDropdown from '../../../../Components/FormField/FormDropdown'

const CollegeDetailCampus = ({ college }) => {
  const campRef = React.useRef()

  const getRefNameList = () => {
    var refList = []

    for (var i = 0; i < college.campuses.length; i++) {
      if (college.campuses[i]) {
        const refName = {
          name:
            'reference_name' in college.campuses[i]
              ? college.campuses[i].reference_name
              : 'default_ref',
          value: college.campuses[i]._id,
        }
        refList.push(refName)
      }
    }

    return refList
  }

  const refNameChanged = (e) => {
    campRef.current.swapTab(e.target.value)
  }

  const buildRefNameOption = () => {
    const optionList = []
    const refNameList = getRefNameList()
    if (refNameList) {
      refNameList.map((item) => {
        optionList.push(<option value={item.value}>{item.name}</option>)
      })
    }

    return optionList
  }

  return (
    <DetailsHolder college={college} activePath='/CollegeDetailCampus'>
      {college.campuses.length > 0 && (
        <div className='ml-2 col-3'>
          <FormDropdown label='Reference Name List: ' onChange={refNameChanged}>
            {buildRefNameOption()}
          </FormDropdown>
        </div>
      )}
      <div style={{ pointerEvents: 'none' }}>
        {college.campuses.length == 0 ? (
          <div className='absolute-align-items-center'>
            <p>Currently there is no data available.</p>
          </div>
        ) : (
          <Campus
            campuses={college.campuses}
            institution={college.institution}
            user={college.user}
            ref={campRef}
            isViewAsAdmin={true}
          />
        )}
      </div>
    </DetailsHolder>
  )
}

function mapStateToProps(state) {
  return {
    college: state.admin.college_details,
  }
}

export default connect(mapStateToProps)(CollegeDetailCampus)
